import { render, staticRenderFns } from "./BankEvolution.vue?vue&type=template&id=049b0d91&"
import script from "./BankEvolution.vue?vue&type=script&lang=js&"
export * from "./BankEvolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports